import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

console.log('index.js loading...');


// Suppress cross-origin script errors from Google APIs
window.addEventListener('error', (event) => {
  if (event.message === 'Script error.' || (event.message === 'Script error.' && event.filename === '')) {
    // This is a cross-origin script error (likely from Google APIs)
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true);

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React Error Boundary caught an error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', fontFamily: 'monospace' }}>
          <h1 style={{ color: 'red' }}>React Error Occurred</h1>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            <summary>Click to see error details</summary>
            <p><strong>Error:</strong> {this.state.error && this.state.error.toString()}</p>
            <p><strong>Stack:</strong> {this.state.errorInfo && this.state.errorInfo.componentStack}</p>
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

const container = document.getElementById('root');
console.log('Root container:', container);

if (!container) {
  console.error('CRITICAL: Root element not found!');
} else {
  try {
    const rootElement = (
      <ErrorBoundary>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </ErrorBoundary>
    );

    // Support both react-snap (hydrate) and regular rendering
    if (container.hasChildNodes()) {
      // react-snap pre-rendered content exists, use hydrate
      const { hydrateRoot } = require('react-dom/client');
      hydrateRoot(container, rootElement);
      console.log('React hydrated from pre-rendered content');
    } else {
      // No pre-rendered content, use regular render
      const root = createRoot(container);
      console.log('React root created, rendering app...');
      root.render(rootElement);
      console.log('React render called');
    }
  } catch (error) {
    console.error('CRITICAL ERROR during React initialization:', error);
    document.getElementById('root').innerHTML = `
      <div style="padding: 20px; font-family: monospace; color: red;">
        <h1>Critical React Error</h1>
        <p>${error.message}</p>
        <pre>${error.stack}</pre>
      </div>
    `;
  }
}
